import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// Import top scroll
import ScrollToTopOnNavigation from "./ScrollToTopOnNavigation";
// Import pages
import Index from "./index";
import PageNotFound from "./PageNotFound";
import Service from "./service";
import Login from "./login";
import SignUp from "./signup";
import AddSalary from "./addSalary";
import Explore from "./explore";
import Profile from "./profile";
import Vet from "./vet";
import Salaries from "./salaries";
import Company from "./company";
import About from "./about";
import EmployersPage from "./employers";
import Companies from "./companies";
import './i18n';
import { CompanyProvider } from './contexts/CompanyContext';

// Create router
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Index />
      </>
    ),
  },
  {
    path: "/404/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <PageNotFound />
      </>
    ),
  },
  {
    path: "/service/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Service />
      </>
    ),
  },
  {
    path: "/login/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Login />
      </>
    ),
  },
  {
    path: "/signup/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <SignUp />
      </>
    ),
  },
  {
    path: "/addsalary/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <AddSalary />
      </>
    ),
  },
  {
    path: "/explore/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Explore />
      </>
    ),
  },
  {
    path: "/profile/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Profile />
      </>
    ),
  },
  {
    path: "/vet/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Vet />
      </>
    ),
  },
  {
    path: "/salaries/:role",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Salaries />
      </>
    ),
  },
  {
    path: "/companies/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Companies />
      </>
    ),
  },
  {
    path: "/companies/:companyName",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <Company />
      </>
    ),
  },
  {
    path: "/about/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <About />
      </>
    ),
  },
  {
    path: "/employers/",
    element: (
      <>
        <ScrollToTopOnNavigation />
        <EmployersPage />
      </>
    ),
  },
]);

// Run react inside index.html
ReactDOM.createRoot(document.getElementById("root")).render(
  <CompanyProvider>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </CompanyProvider>

);
